import styled from "styled-components/macro";
import { Text } from "@gcs/design-system/react";

export const Contact = styled.aside(({ theme }) => ({
    borderLeft: "1px solid",
    borderColor: theme.color.brandSecondary.light,
    paddingLeft: "18px"
}));

export const ContactTitle = styled(Text)(({ theme }) => ({
    fontSize: "20px",
    fontWeight: "700",
    lineHeight: "150%",
    marginBottom: "0px",
    color: theme.color.brandPrimary.light,

    [theme.breakpoint.lg()]: {
        fontSize: "24px"
    }
}));

export const ContactEmail = styled.a(({ theme }) => ({
    fontSize: "18px",
    fontWeight: "500",
    lineHeight: "160%",
    color: theme.color.brandPrimary.light,

    [theme.breakpoint.lg()]: {
        fontSize: "20px"
    }
}));